import { FC } from 'react';

export interface ContributorCardProps {
  name: string;
  storageSize: string;
  avatarColor: string;
  onClick?: () => void;
}

export const ContributorCard: FC<ContributorCardProps> = ({
  name,
  storageSize,
  avatarColor,
  onClick
}) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-3 flex items-center gap-2.5 w-[230px] h-[257px]">
      <div className="flex flex-col items-center gap-5 w-[195px]">
        {/* Avatar */}
        <div
          className="w-[149px] h-[149px] rounded-full flex-shrink-0"
          style={{ backgroundColor: avatarColor }}
        />

        {/* Name and Storage Info */}
        <div className="flex flex-row justify-between items-center self-stretch gap-[108px]">
          <div className="flex flex-col w-[62px]">
            <h3 className="text-xl font-bold text-inputbox-text">{name}</h3>
            <p className="text-sm text-gray-1">{storageSize}</p>
          </div>

          {/* Forward Arrow Button */}
          <button
            onClick={onClick}
            className="flex justify-center items-center gap-2.5 p-1 w-[25px] h-[25px] bg-primary rounded">
            <svg
              width="10"
              height="17"
              viewBox="0 0 10 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 1L8.5 8.5L1 16"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
